import { useMemo } from 'react';

import { useFishGroupsController_getCageHistory } from '@/services/hooks';
import type { CageFishGroupHistoryItemDto } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import type { UseGetCageFishGroupHistoryResult } from './historyTypes';
import { mapCageFishGroupHistoryToDomain } from './mappers';

export const useGetCageFishGroupHistory = (
    clientId: number,
    cageId: number | null,
    options?: DomainQueryOptions<CageFishGroupHistoryItemDto[]>
): UseGetCageFishGroupHistoryResult => {
    // The cageId can be null while the modal is closed; in that case we
    // disable the underlying query so we don't fire requests against a
    // synthetic cageId=0 path.
    const query = useFishGroupsController_getCageHistory(clientId, cageId ?? 0, {
        ...options,
        enabled: cageId !== null && options?.enabled !== false,
    });

    const history = useMemo(() => {
        if (!query.data?.data) return [];
        return mapCageFishGroupHistoryToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: history,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
